/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  (function() {
    function quantityRuleFromVariant(variant) {
      var rule = (variant && variant.quantity_rule) || {};
      var min = Number(rule.min);
      var increment = Number(rule.increment);
      var max = rule.max == null || rule.max === '' ? NaN : Number(rule.max);

      return {
        min: Number.isFinite(min) && min > 0 ? min : 1,
        increment: Number.isFinite(increment) && increment > 0 ? increment : 1,
        max: Number.isFinite(max) ? max : null,
      };
    }

    function isValidQuantity(value, rule) {
      if (!Number.isFinite(value) || value < rule.min) return false;
      if (rule.max != null && value > rule.max) return false;
      return (value - rule.min) % rule.increment === 0;
    }

    function applyQuantityRule(root, variant) {
      if (!root || !variant) return;

      var rule = quantityRuleFromVariant(variant);
      var inputs = root.querySelectorAll('input.quantity__input[name="quantity"], input[type="hidden"][name="quantity"]');

      inputs.forEach(function (input) {
        var previous = input.value;
        input.min = String(rule.min);
        input.step = String(rule.increment);

        if (rule.max == null) {
          input.removeAttribute('max');
        } else {
          input.max = String(rule.max);
        }

        var next = isValidQuantity(Number(input.value), rule) ? Number(input.value) : rule.min;
        input.value = String(next);

        var popout = input.closest('popout-select');
        var toggleText = popout && popout.querySelector('[data-popout-toggle-text]');
        if (toggleText) toggleText.textContent = input.value;

        if (input.value !== previous) {
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    document.addEventListener('theme:variant:change', function (event) {
      applyQuantityRule(event.target, event.detail && event.detail.variant);
    });
  })();

  (function() {
    var formatting = false;

    function numericId(value) {
      var match = String(value || '').match(/(\d+)\s*$/);
      return match ? match[1] : '';
    }

    function moneyFromCents(cents) {
      var amount = (Number(cents) / 100).toFixed(2);
      var template = window.clayProductPriceConfig && window.clayProductPriceConfig.priceDisplayText;
      if (template) return template.replace('{{amount}}', amount);
      return '$' + amount;
    }

    function shopifyPriceText(wrap) {
      var displayed = wrap.querySelector('[data-product-price]');
      var displayedText = displayed ? displayed.textContent.trim() : '';
      var section = wrap.closest('[data-section-type="product"]');
      var jsonEl = section && section.querySelector('[data-product-json]');
      var table = wrap.querySelector('.clay-quantity-grid-table-container');

      if (jsonEl) {
        try {
          var product = JSON.parse(jsonEl.textContent);
          var variantId = selectedVariantId(wrap) || numericId(table && table.getAttribute('data-variant-id'));
          var variant = (product.variants || []).find(function (item) {
            return String(item.id) === variantId;
          }) || (product.variants || [])[0];
          if (variant && variant.price != null) return moneyFromCents(variant.price);
        } catch (error) {
          /* Fall through to the visible price. */
        }
      }

      var compare = wrap.querySelector('[data-compare-price]');
      var compareText = compare && compare.textContent.trim();
      return compareText || displayedText;
    }

    function buyOrMoreLabel(text) {
      var raw = String(text || '').replace(/\s+/g, ' ').trim();
      if (/or more$/i.test(raw)) return raw;
      var match = raw.match(/^(?:Buy\s+)?(\d+)/i);
      if (!match) return raw;
      return 'Buy ' + match[1] + ' or more';
    }

    var selectedId = '';

    function selectedVariantId(wrap) {
      if (selectedId) return selectedId;

      var section = wrap && (wrap.closest('[data-section-type="product"]') || wrap.closest('[data-quick-add-modal]'));
      if (!section) return '';

      var input = section.querySelector('input[name="id"][form]') || section.querySelector('[data-form-wrapper] [name="id"]');
      return numericId(input && input.value);
    }

    function clayOverlaySelector() {
      return '.clay-savings-text-container, .clay-quantity-grid-table-container, .clay-tax-price-container';
    }

    function stripClayOverlays(wrap) {
      if (!wrap) return;
      wrap.querySelectorAll(clayOverlaySelector()).forEach(function (el) {
        el.remove();
      });
    }

    // Clay's Dawn path removes leftover savings when the variant has no
    // rule. Broadcast skips that update, and may also rewrite the old
    // savings node using ?variant= from the URL — which Broadcast has
    // not updated yet when theme:variant:change fires.
    function removeStaleClayNodes(wrap) {
      var currentId = selectedVariantId(wrap);
      if (!currentId) return;

      wrap.querySelectorAll(clayOverlaySelector()).forEach(function (el) {
        var nodeId = numericId(el.getAttribute('data-variant-id'));
        if (nodeId && nodeId !== currentId) el.remove();
      });
    }

    function formatClayQuantityGrid(wrap) {
      if (!wrap || formatting) return;
      formatting = true;
      removeStaleClayNodes(wrap);
      var table = wrap.querySelector('.clay-quantity-grid-table');
      if (!table) {
        formatting = false;
        return;
      }

      var retail = shopifyPriceText(wrap);

      table.querySelectorAll('tbody tr').forEach(function (row) {
        var cells = row.querySelectorAll('td');
        if (!cells.length) return;

        var quantityCell = cells[0];
        var nextQuantity = buyOrMoreLabel(quantityCell.textContent);
        if (quantityCell.textContent.trim() !== nextQuantity) {
          quantityCell.textContent = nextQuantity;
        }

        if (cells.length < 2 || !retail) return;

        var priceCell = cells[1];
        if (priceCell.querySelector('s')) return;

        var sale = priceCell.textContent.trim();
        if (!sale || sale === retail) return;

        var saleEl = document.createElement('span');
        saleEl.className = 'clay-quantity-grid-sale-price';
        saleEl.textContent = sale;

        var strikeEl = document.createElement('s');
        strikeEl.className = 'product__price--strike';
        strikeEl.textContent = retail;

        priceCell.textContent = '';
        priceCell.appendChild(saleEl);
        priceCell.appendChild(document.createTextNode(' '));
        priceCell.appendChild(strikeEl);
      });

      formatting = false;
    }

    function watchPriceWrap(wrap) {
      formatClayQuantityGrid(wrap);
      new MutationObserver(function () {
        formatClayQuantityGrid(wrap);
      }).observe(wrap, { childList: true, subtree: true });
    }

    document.querySelectorAll('.product__content .product__price__wrap').forEach(watchPriceWrap);

    document.addEventListener('theme:variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      selectedId = variant && variant.id ? numericId(variant.id) : '';
      var wrap = event.target.querySelector && event.target.querySelector('.product__price__wrap');
      if (!wrap) return;
      stripClayOverlays(wrap);
      formatClayQuantityGrid(wrap);
    });
  })();

  (function() {
    var $discountForm = document.querySelector('.discount-code-form')
    console.log($discountForm)
    if ($discountForm) {
      $discountForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var discountInput = e.target.querySelector('.discount-code-input');
        var $result = document.querySelector('#result');
        if (discountInput.value === 'Shizuoka') {
          $result.innerHTML = 'Congratulations! You got 10% off! Use Discount Code: <span class="discount-code-display">Matcha10%</span>';
          e.target.style.display = 'none';
        } else {
          result.innerHTML = 'Sorry, ' + discountInput.value + ' is not right, please try again';
        }
      });
    }
  }());

  (function () {
    function applyCardVariant(card, source) {
      if (!card || !source) return;

      var id = source.getAttribute('data-variant-id') || source.value;
      var title = source.getAttribute('data-variant-title');
      var url = source.getAttribute('data-variant-url');
      if (!id) return;

      card.setAttribute('data-variant-id', id);

      card.querySelectorAll('[data-card-variant-pill]').forEach(function (button) {
        var on = button.getAttribute('data-variant-id') === id;
        button.classList.toggle('is-selected', on);
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var select = card.querySelector('[data-card-variant-select]');
      if (select && select.value !== id) select.value = id;

      card.querySelectorAll('[data-card-variant-id]').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-card-variant-id') === id);
      });

      if (url) {
        card.querySelectorAll('[data-product-link]').forEach(function (link) {
          link.setAttribute('href', url);
        });
      }

      var buyId = card.querySelector('[data-card-buy-id]');
      if (buyId) buyId.value = id;

      var buyQty = card.querySelector('[data-card-buy-qty]');
      var minQty = parseInt(source.getAttribute('data-qty-min'), 10);
      if (buyQty && minQty > 0) buyQty.value = String(minQty);

      var buyBtn = card.querySelector('[data-card-buy]');
      if (buyBtn) buyBtn.disabled = source.getAttribute('data-available') === 'false';

      var titleVariant = card.querySelector('[data-card-title-variant]');
      if (titleVariant && title) titleVariant.textContent = title;

      updateCardVariantArrows(card);

      var imageRoot = card.querySelector('[data-product-image]');
      if (!imageRoot) return;

      imageRoot.querySelectorAll('[data-variant-title]').forEach(function (image) {
        image.classList.toggle('is-visible', image.getAttribute('data-variant-title') === title);
      });
    }

    function selectedCardVariantIndex(card) {
      var pills = Array.prototype.slice.call(card.querySelectorAll('[data-card-variant-pill]'));
      var index = pills.findIndex(function (pill) {
        return pill.classList.contains('is-selected');
      });
      return { pills: pills, index: index < 0 ? 0 : index };
    }

    function updateCardVariantArrows(card) {
      var state = selectedCardVariantIndex(card);
      var prev = card.querySelector('[data-card-variant-arrow="prev"]');
      var next = card.querySelector('[data-card-variant-arrow="next"]');
      var atStart = state.index <= 0;
      var atEnd = state.index >= state.pills.length - 1;

      if (prev) {
        prev.classList.toggle('is-hidden', atStart);
        prev.setAttribute('aria-hidden', atStart ? 'true' : 'false');
        prev.tabIndex = atStart ? -1 : 0;
      }
      if (next) {
        next.classList.toggle('is-hidden', atEnd);
        next.setAttribute('aria-hidden', atEnd ? 'true' : 'false');
        next.tabIndex = atEnd ? -1 : 0;
      }
    }

    function cycleCardVariant(card, direction) {
      if (!card) return;
      var state = selectedCardVariantIndex(card);
      if (state.pills.length < 2) return;
      var next = state.index + direction;
      if (next < 0 || next >= state.pills.length) return;
      applyCardVariant(card, state.pills[next]);
    }

    document.addEventListener('click', function (event) {
      var pill = event.target.closest('[data-card-variant-pill]');
      if (!pill) return;

      event.preventDefault();
      event.stopPropagation();

      applyCardVariant(pill.closest('[data-grid-item]'), pill);
    });

    document.addEventListener('click', function (event) {
      var arrow = event.target.closest('[data-card-variant-arrow]');
      var hit = event.target.closest('[data-card-variant-arrow-hit]');
      if (!arrow && !hit) return;

      event.preventDefault();
      event.stopPropagation();

      if (!arrow || arrow.classList.contains('is-hidden')) return;

      var direction = arrow.getAttribute('data-card-variant-arrow') === 'prev' ? -1 : 1;
      cycleCardVariant(arrow.closest('[data-grid-item]'), direction);
    });

    document.addEventListener('change', function (event) {
      var select = event.target.closest('[data-card-variant-select]');
      if (!select) return;

      var option = select.options[select.selectedIndex];
      applyCardVariant(select.closest('[data-grid-item]'), option);
    });
  })();

  (function () {
    function setAccordion(wrap, open) {
      if (!wrap) return;
      wrap.classList.toggle('is-open', open);
      var toggle = wrap.querySelector('[data-drawer-accordion-toggle]');
      var panel = wrap.querySelector('[data-drawer-accordion-panel]');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.hidden = !open;
    }

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-drawer-accordion-toggle]');
      if (!toggle) return;
      event.preventDefault();
      var wrap = toggle.closest('[data-drawer-accordion]');
      setAccordion(wrap, !wrap.classList.contains('is-open'));
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var toggle = event.target.closest('[data-drawer-accordion-toggle]');
      if (!toggle) return;
      event.preventDefault();
      var wrap = toggle.closest('[data-drawer-accordion]');
      setAccordion(wrap, !wrap.classList.contains('is-open'));
    });

    document.addEventListener('theme:drawer:close', function () {
      document.querySelectorAll('[data-drawer-accordion].is-open').forEach(function (wrap) {
        setAccordion(wrap, false);
      });
    });
  })();

  (function () {
    var allowed = {
      all: true,
      featured: true,
      matcha: true,
      hojicha: true,
      genmaicha: true,
      accessories: true,
    };

    function groupFromLocation() {
      var group = (new URLSearchParams(window.location.search).get('group') || '').toLowerCase();
      return allowed[group] ? group : 'all';
    }

    function applyGroup(root, group, updateHistory) {
      if (!root) return;
      if (!allowed[group]) group = 'all';
      root.setAttribute('data-active-group', group);
      root.querySelectorAll('[data-filter-pill]').forEach(function (pill) {
        var on = pill.getAttribute('data-filter-pill') === group;
        pill.classList.toggle('is-selected', on);
        if (on) pill.setAttribute('aria-current', 'page');
        else pill.removeAttribute('aria-current');
      });
      if (!updateHistory) return;
      var url = new URL(window.location.href);
      if (group === 'all') url.searchParams.delete('group');
      else url.searchParams.set('group', group);
      window.history.pushState({ shopGroup: group }, '', url.pathname + url.search + url.hash);
    }

    document.addEventListener('click', function (event) {
      var pill = event.target.closest('[data-filter-pill]');
      if (!pill) return;
      var root = pill.closest('[data-shop-filters]');
      if (!root) return;
      event.preventDefault();
      applyGroup(root, pill.getAttribute('data-filter-pill'), true);
    });

    window.addEventListener('popstate', function () {
      document.querySelectorAll('[data-shop-filters]').forEach(function (root) {
        applyGroup(root, groupFromLocation(), false);
      });
    });

    document.querySelectorAll('[data-shop-filters]').forEach(function (root) {
      applyGroup(root, groupFromLocation(), false);
    });
  })();


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
